import React, { useContext, useState, useEffect, useRef } from "react";
import Button from "../../components/ui/button/Button";
import InputText from "../../components/ui/input_text/InputText";
import styles from "./styles/Result.module.css";
import { useTranslation } from "react-i18next";

/**
 * The Receipt component
 * Handles recipt download if available
 */

const Receipt = ({
    handleChange, // {function} - handle change event for the input field
    handleSubmit, // {function} - handle submit event for the form
    last4, // {string} - the last 4 digits of the credit card
    formButtonDisable, // {boolean} - form button disable flag
    inProcess, // {boolean} - in process flag
}) => {
    const { t } = useTranslation();
    const [hoverFlag, setHoverFlag] = useState(false);
    const last4InputRef = useRef(null); // reference to the last 4 digits input field

    // Set focus to the text input when the component mounts
    useEffect(() => {
        last4InputRef.current && last4InputRef.current.focus();
    }, []);

    return (
        <section
            className={`${styles.result_receipt_container} flex-container`}
        >
            <form
                className={`${styles.result_receipt_media_container} flex-container`}
            >
                <div className={`${styles.result_receipt_input_container}`}>
                    <InputText
                        ref={last4InputRef}
                        placeholder={t(`last 4 digits`)}
                        letterSpacing={"1.5rem"}
                        label={t(`last 4 credit card digits`)}
                        inputId="last4Input"
                        inputValue={last4}
                        handleChangeFunction={handleChange}
                        required={hoverFlag && formButtonDisable}
                        maxLength={4}
                    />
                </div>
                <div className={`${styles.result_receipt_button_container}`}>
                    <Button
                        body={t(`check receipt`)}
                        type={"button"}
                        disabled={formButtonDisable || inProcess}
                        setHoverFlag={setHoverFlag}
                        onClickFuction={handleSubmit}
                    />
                </div>
            </form>
        </section>
    );
};

export default Receipt;
